import { useParams } from 'react-router';

function useCompanyIdRouteMatch() {
    const { companyId } = useParams();
    return companyId;
}

export default useCompanyIdRouteMatch;
